(function($, undefined) {
	
	'use strict';
	var isLoggedIn = false;
	var isMobile = false;
	var win = $(window);
	var winWidth;
	var winHeight;
	
	var header;
	var navItems;
	
	var toggleMenuBtn;
	var headerHeight;
	var addContentMargin = !$('body').hasClass('minified-header-footer');
	
	var toggleScroll = function () {
		if ($('html').hasClass('no-scroll')) {
			removeScroll();
		} else {
			addScroll();
		}
	};
	
	var addScroll = function () {
		$('html').removeClass('no-scroll');
		changeScrollDiff(0);
	};
	
	var removeScroll = function () {
		var w1 = win.width();
		$('html').addClass('no-scroll');
		var w2 = win.width();
		changeScrollDiff(w2 - w1);
	};
	
	var changeScrollDiff = function (diff) {
		$('.js-scroll-padding').css('padding-right', diff + 'px');
		$('.js-scroll-right').css('right', diff + 'px');
	};
	
	var onClickMenuToggle = function () {
		if (!!$('body').hasClass('menu-open')) {
			var transitionEnd = 'transitionend webkitTransitionEnd oTransitionEnd otransitionend';
			$('body').removeClass('menu-open');
			
			header.on(transitionEnd, function(e) {
				$('html').removeClass('no-scroll');
				changeScrollDiff(0);
				$(this).off(e);
			});
		} else {
			var target = 0;
			
			if ($('.site-header').css('scroll-y') !== 'fixed' && $('.site-header').offset().top > 0) {
				target = $('.site-header').offset().top;
			}
			
			if (win.scrollTop() <= $('.site-header').offset().top) {
				$('html').animate({scrollTop: target}, 300);
				$('body').animate({scrollTop: target}, 300, function () {
					openMenu();
				});
			} else {
				openMenu();
			}
		}
	};
	
	var openMenu = function () {
		$('body').addClass('menu-open');
		toggleScroll();
	};
	
	var closeMenu = function () {
		if ($('body').hasClass('menu-open')) {
			$('body').removeClass('menu-open');
			toggleScroll();
		}
	};
	
	var updateNavSelected = function (page) {
		navItems.removeClass('selected');
		var handleObj = $('.main-content ' + page);
		var handle = handleObj.attr('data-page-nav');
		
		navItems.each(function () {
			var t = $(this);
			
			if (t.data('pageNav') === handle) {
				t.addClass('selected');
			}
		});
	};

	var updateMainContentMargin = function(checkHeight) {
		if (checkHeight) {
			var height = $('.site-header').height();
			headerHeight = height;
		}

		var searchHeight = 62;

		if ($('.resp-detector-ph').css('visibility') === 'visible') {
			searchHeight = 46;
		}

		var newHeight = headerHeight;
		if ($('body').hasClass('search-open')) {
			newHeight = headerHeight + searchHeight;
		}

		$('.main-content').css('margin-top', newHeight +'px');
		$('.demo-player-popup').css('top', (newHeight + 10) +'px');
	};

	var toggleSearch = function() {
		$('body').toggleClass('search-open');
		$('.site-header-bottom-inner.search').slideToggle(function () {
			$('.header-search-input').focus();
		});
		if (addContentMargin) {
			updateMainContentMargin(false);
		}
	};

	var toggleUserDesktopMenu = function() {
		var ctn = $('.whole-container');
		
		if (ctn.hasClass('pushed')) {
			removeDesktopMenu();
		} else {
			ctn.addClass('pushed');
			setTimeout(function() {
				$(document).on('click', outsideClickMenu);
			}, 200);
		}
	};
	
	var removeDesktopMenu = function () {
		$('.whole-container').removeClass('pushed');
		$(document).off('click', outsideClickMenu);
	};
	
	var outsideClickMenu = function () {
		if (!$(event.target).closest('.pushed-user-menu-ctn').length && !$(event.target).closest('.popover').length && !$(event.target).closest('.tour-backdrop').length) {
			removeDesktopMenu();
		}
	};

	var showLeftMenu = function() {
		$('.mobile-side-menu.left').toggleClass('open');
		onClickMenuToggle();
	};

	var showRightMenu = function() {
		$('.mobile-side-menu.right').toggleClass('open');
		onClickMenuToggle();
	};

	var toggleLoginPopover = function() {
		$('.login-popover-mobile').toggleClass('open');
	};

	var closeSideMenus = function() {
		$('.mobile-side-menu').removeClass('open');
		$('html').removeClass('no-scroll');
	};

	var headerScroll = function() {
		if (window.pageYOffset !== 0) {
			$('.site-header').addClass('scrolled');
		} else {
			$('.site-header').removeClass('scrolled');
		}
	};

	var toggleHeaderPreview = function() {
		var t = $(this);
		var id = t.attr('data-id');
		var previewCtn = $('.header-preview-ctn[data-id=' + id +']');
		var delay = 0;

		$('.header-preview-ctn.open').each(function() {
			if ($(this).attr('data-id') !== id) {
				delay = 300;
				$(this).slideUp();
				$(this).removeClass('open');
			}
		});

		setTimeout(function() {
			previewCtn.slideToggle();
			previewCtn.toggleClass('open');
		}, delay);
	};

	var closeHeaderPreview = function() {
		var t = $(this);

		t.closest('.header-preview-ctn').slideUp();
	};

	var toggleSubNav = function() {
		$(this).hasClass('subnav-open') ? $(this).removeClass('subnav-open') : $(this).addClass('subnav-open');
	
		if ($('.resp-detector-sm').css('visibility') === 'visible') {
			$(this).find('.sub-nav-ctn').slideToggle();
		}
	};
	
	var init = function () {
		winWidth = win.width();
		winHeight = win.height();
		$('html').removeClass('no-scroll');
		
		header = $('.site-header');
		navItems = $('.nav-item-link', header);
		
		toggleMenuBtn = $('.site-header-menu-toggle-btn', header);

		if (!(navigator.userAgent.includes("Chrome") || navigator.userAgent.includes("Firefox"))) {
			$('.site-browser-notice-ctn').removeClass('hide');
		}

		$('.header-search-btn:not(.header-search-input-icon)').click(toggleSearch);
		$('.header-account-btn').click(toggleUserDesktopMenu);
		
		if ($('body').hasClass('is-logged-in')) {
			isLoggedIn = true;
		}
		
		toggleMenuBtn.click(showLeftMenu);
		$('.header-account-responsive-btn:not(.show-login)').click(showRightMenu);
		$('.header-account-responsive-btn.show-login').click(toggleLoginPopover);
		$('.side-menu-overlay').click(closeSideMenus);
		$('.nav-item-link:not(.has-subnav)').on('click', closeSideMenus);
		$('.open-header-preview-btn').click(toggleHeaderPreview);
		$('.close-header-preview-btn').click(closeHeaderPreview);
		$('.nav-item-link.has-subnav').click(toggleSubNav);
		
		if (addContentMargin) {
			updateMainContentMargin(true);

			setTimeout(function() {
				$('html').animate({scrollTop: 0});
				$('body').animate({scrollTop: 0});
			}, 300);
		}
		
		if (!addContentMargin) {
			win.scroll(function() {
				headerScroll();
			});
			headerScroll();
		}
		
		win.resize(function() {
			if (win.width() != winWidth) {
				winHeight = win.height();
				winWidth = win.width();
				$('.whole-container').removeClass('pushed');
				$('.login-popover-mobile').removeClass('open');
				closeSideMenus();
				$('html').removeClass('no-scroll');
				if ($('body').hasClass('search-open')) {
					toggleSearch();
					setTimeout(function() {
						if (addContentMargin) {
							updateMainContentMargin(true);
						}
					}, 400);
				}
				if (addContentMargin) {
					updateMainContentMargin(true);
				}
			}
		});

		if ($('.has-processing, .processing-loader').length > 0) {
			$('.has-processing, .processing-loader').attr('data-processing-content', $('body').attr('data-processing'));
		}
		
	};
	
	$(init);
	
	Fw.modules.export('header', {
		removeScroll: removeScroll,
		addScroll: addScroll
	});
	
})(jQuery);
